// extracted by mini-css-extract-plugin
export default {"page":"m2-z","cartModal":"n2-z","checkout":"o2-z","placeholder":"p2-z","account":"q2-z"};